// Per-page <title> and meta description used by usePageSeo, keyed by route key (see App.jsx PAGES).
const SEO = {
  home: {
    title: "Home",
    description:
      "Capital Care International Hospital (CCIH) is a modern secondary & tertiary care hospital in G-8, Islamabad offering 24/7 emergency, ICU, NICU, surgery and 100+ specialist doctors across 28 departments.",
  },
  "about-us": {
    title: "About Us",
    description:
      "Learn about Capital Care International Hospital's mission, facilities, and commitment to compassionate, world-class healthcare in Islamabad, Pakistan.",
  },
  "about-vision-mission": {
    title: "Vision & Mission",
    description:
      "Discover the vision, mission, and core values that guide patient care at Capital Care International Hospital.",
  },
  "about-news-events": {
    title: "News & Events",
    description:
      "Stay up to date with the latest news, milestones, and events from Capital Care International Hospital.",
  },
  "about-gallery": {
    title: "Hospital Tour & Gallery",
    description:
      "Take a virtual tour of Capital Care International Hospital's wards, operation theatres, ICU, NICU, and patient facilities.",
  },
  "about-faqs-complaints": {
    title: "FAQs & Complaints",
    description:
      "Find answers to frequently asked questions or reach patient support to raise a complaint at Capital Care International Hospital.",
  },
  services: {
    title: "Our Services",
    description:
      "Explore in-patient and out-patient services at Capital Care International Hospital, including emergency care, surgery, ICU, NICU, diagnostics and OPD consultations.",
  },
  "services-inpatient": {
    title: "In-Patient Services",
    description:
      "Surgical, emergency, ICU and NICU in-patient services with 24/7 specialist support at Capital Care International Hospital.",
  },
  "services-outpatient": {
    title: "Out-Patient Services",
    description:
      "OPD consultations, follow-ups, wellness care and diagnostics available at Capital Care International Hospital.",
  },
  packages: {
    title: "Our Doctors",
    description:
      "Find specialists by department at Capital Care International Hospital and book an appointment with our expert doctors.",
  },
  "doctor-details": {
    title: "Doctor Profile",
    description:
      "View doctor profile, specialty, and experience at Capital Care International Hospital.",
  },
  specialties: {
    title: "Specialties",
    description:
      "Browse medical and surgical specialties available at Capital Care International Hospital, from cardiology to orthopedics.",
  },
  corporate: {
    title: "Corporate Wellness",
    description:
      "Corporate wellness programs and employee health packages from Capital Care International Hospital.",
  },
  contact: {
    title: "Contact Us",
    description:
      "Get in touch with Capital Care International Hospital in G-8, Islamabad. Call, email, or visit us — emergency care available 24/7.",
  },
  branches: {
    title: "Careers",
    description:
      "Explore current job openings and apply for a career at Capital Care International Hospital.",
  },
  "career-details": {
    title: "Job Details",
    description:
      "View job details and requirements for open positions at Capital Care International Hospital.",
  },
  "career-apply": {
    title: "Apply Now",
    description:
      "Submit your application for a career opportunity at Capital Care International Hospital.",
  },
};

export default SEO;
